const imageUrl = (url, width = 0, height = 0, cut = 1, useOriginal) => {
  let cdn = window.location.host === 'sspai.com' ? 'https://cdnfile.sspai.com/' : 'https://test-images.sspai.com/'
  if (!url) {
    return ''
  }
  if (useOriginal === true) {
    return cdn + url
  }
  let thumbUrl = ''
  if (url.indexOf('http') === 0) {
    url = url.replace('https://cdnfile.sspai.com/', '')
    url = url.replace('https://test-images.sspai.com/', '')
    if (url.indexOf('https://cdn-static.sspai.com') === 0) {
      cdn = ''
    }
  }
  let size = ''
  let cutStr = ''
  let flag = ''
  if (!width && !height) {
    return cdn + url + `?imageMogr2/auto-orient/quality/95`
  }
  if (width === 0) {
    size = `x` + height
    flag = 'r'
  } else if (height === 0) {
    size = width + 'x'
  } else {
    size = width + 'x' + height
    flag = 'r'
  }
  if (cut) {
    cutStr = `/gravity/Center/crop/${size}`
  }
  if (url) {
    thumbUrl = cdn + url + `?imageMogr2/auto-orient/quality/95/thumbnail/!${size}${flag}${cutStr}/interlace/1`
  } else {
    thumbUrl = `${cdn}/404.png?imageMogr2/thumbnail/!${size}${flag}${cutStr}`
  }
  return thumbUrl
}
export default imageUrl
